/* eslint-disable no-mixed-operators */
import { toCents, correctPrice } from '@/utils/helpers';

export default class Contract {

  constructor(params) {
    const getters = [
      'lastTradePriceAsCents',
      'lastClosePriceAsCents',
      'changePriceAsCents',
      'userAveragePricePerShareAsCents',
      'userChangePriceAsCents',
      'buyYesCostAsCents',
      'buyNoCostAsCents',
      'sellYesCostAsCents',
      'sellNoCostAsCents',
      'userOpenOrders',
      'totalSharesTradedDisplay',
      'mode',
      'lastTradePriceAsCentsWithZeroBypass',
    ];
    Object.keys(params).forEach((key) => {
      if (getters.indexOf(key) < 0) { // to avoid setter exception
        this[key] = params[key];
      }
    });
  }

  get lastTradePriceAsCents() {
    return toCents(this.lastTradePrice);
  }

  get lastTradePriceAsCentsWithZeroBypass() {
    if (this.lastTradePriceAsCents === 0) {
      const bestYes = this.bestYesPrice || 0;
      const bestNo = this.bestNoPrice || 0;
      const price = (1 + bestYes - bestNo) / 2;
      return correctPrice(toCents(price));
    }

    return this.lastTradePriceAsCents;
  }

  get lastClosePriceAsCents() {
    return toCents(this.lastClosePrice);
  }

  get changePriceAsCents() {
    return this.lastTradePriceAsCents - this.lastClosePriceAsCents;
  }

  get userAveragePricePerShareAsCents() {
    return toCents(this.userAveragePricePerShare);
  }

  get userChangePriceAsCents() {
    const roundedAverage = Math.round(this.userAveragePricePerShare * 100) / 100;
    if (this.mode === 'no') {
      return toCents(1 - this.lastTradePrice - roundedAverage);
    }
    return toCents(this.lastTradePrice - roundedAverage);
  }

  get buyYesCostAsCents() {
    return correctPrice(toCents(this.bestYesPrice || this.bestYesCost));
  }

  get buyNoCostAsCents() {
    return correctPrice(toCents(this.bestNoPrice || this.bestNoCost));
  }

  get sellYesCostAsCents() {
    return correctPrice(100 - this.buyNoCostAsCents);
  }

  get sellNoCostAsCents() {
    return correctPrice(100 - this.buyYesCostAsCents);
  }

  get userOpenOrders() {
    return this.userOpenOrdersBuyQuantity + this.userOpenOrdersSellQuantity;
  }

  get mode() {
    if (this.userQuantity === 0 && this.userOpenOrders === 0) return '';
    if (this.userPrediction === 0) return 'no';
    if (this.userPrediction === 1) return 'yes';
    return '';
  }

  get totalSharesTradedNumber() {
    return this.totalSharesTraded || this.totalTrades || 0;
  }

  get totalSharesTradedDisplay() {
    const value = this.totalSharesTradedNumber;
    return value.toLocaleString();
  }

}



// WEBPACK FOOTER //
// ./src/models/contract.js